var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowNextProfile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9px",
    height: "16px",
    viewBox: "0 0 9 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrowNextProfile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.73286344,14.76 C7.58696035,14.76 7.45929515,14.7059341 7.34986784,14.5978022 L0,7.35296703 L7.29515419,0.162197802 C7.51400881,-0.0540659341 7.86052863,-0.0540659341 8.06114537,0.162197802 C8.28,0.378461538 8.28,0.720879121 8.06114537,0.919120879 L1.55022026,7.35296703 L8.11585903,13.8408791 C8.33471366,14.0571429 8.33471366,14.3995604 8.11585903,14.5978022 C8.00643172,14.7059341 7.87876652,14.76 7.73286344,14.76 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RHP-Search--Desktop-v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Profile-Empty-state",
    transform: "translate(-1310.000000, -168.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrowNextProfile",
    transform: "translate(1310.000000, 168.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colour/mid-grey",
    transform: "translate(4.540000, 8.300000) scale(-1, 1) translate(-4.540000, -8.300000) translate(0.040000, 0.800000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#010101",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)",
    fill: "#646464",
    id: "colour/dark-grey"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.680000, -2.880000)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 19.7142857,
    height: 19.9459459
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowNextProfile);
export default __webpack_public_path__ + "static/media/arrowNextProfile.c479bb72a29e0f6e3286f01c5a5dc51a.svg";
export { ForwardRef as ReactComponent };